import { Button, type ButtonProps } from '@chakra-ui/react';
import type React from 'react';
import type { ReactNode } from 'react';

interface PrimaryButtonProps extends Omit<ButtonProps, 'colorPalette'> {
  children: ReactNode;
  leftIcon?: ReactNode;
  buttonVariant?: 'primary' | 'secondary';
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  leftIcon,
  buttonVariant = 'primary',
  ...props
}) => {
  // Determine button style based on variant
  const buttonProps =
    buttonVariant === 'secondary'
      ? {
          colorPalette: 'orange',
          variant: 'surface' as const,
          borderRadius: 'md' as const,
          size: 'md' as const,
          display: 'flex' as const,
          alignItems: 'center' as const,
          gap: 2 as const,
          ...props,
        }
      : {
          colorPalette: 'blue',
          borderRadius: 'md' as const,
          size: 'md' as const,
          display: 'flex' as const,
          alignItems: 'center' as const,
          gap: 2 as const,
          ...props,
        };

  return (
    <Button {...buttonProps}>
      {leftIcon}
      {children}
    </Button>
  );
};
